import { TWITCH_OAUTH_URL,
         YOUTUBE_OAUTH_URL,
         YOUTUBE_OAUTH_URL_CHATBOT_MANAGER
} from '../constants/twitchConstants';
import {
    FETCH_STRIPE_PAYMENTS,
    DELETE_STRIPE_PAYMENTS,
    FETCH_WALLET_DETAILS,
    FETCH_SOCIAL_INFORMATION,
} from '../constants/urls';
import eventBus  from './globalPubSub';

var ua = navigator.userAgent.toLowerCase();

var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

export function logout(){
    localStorage.setItem(
        'login-details', '');
    eventBus.dispatch(
        'user-logged-out',{});
    return true;
}

export function getLoginInformation(){
    let loginDetailsStr = localStorage.getItem(
        'login-details');
    let loginDetails;
    if(loginDetailsStr){
        loginDetails = JSON.parse(loginDetailsStr);
    }
    else{
        return false;
    }
    return loginDetails;
}

export async function setPaymentDetails(){
    console.log('setting token')
    let loginInformation = getLoginInformation();
    localStorage.setItem(
        'payment-details', '');
    let resp;
    try{
        resp = await fetch(FETCH_STRIPE_PAYMENTS, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`
	    }
        });
    }
    catch (e){
        localStorage.setItem(
            'payment-details', '');
        eventBus.dispatch(
            'payment-details-changed', undefined
        )
        return;
    }
    let respData = await resp.json();
    if(respData.data.paymentMethod){
        localStorage.setItem(
            'payment-details',
            JSON.stringify(respData.data.paymentMethod));
        eventBus.dispatch(
            'payment-details-changed', respData.data.paymentMethod
        )
    }
    else{
        eventBus.dispatch('payment-details-changed', undefined);
    }    
    return resp;
}

export async function loginUser(data){
    localStorage.setItem(
        'login-details', JSON.stringify(data.data));
    await setPaymentDetails();
    eventBus.dispatch(
        'user-logged-in', data.data);
    window.analytics.track('login_complete', {
        data: data.data,
        type: 'web'
    });
}

export async function loginToTwitch(){
    let finalURL;
    const socketAddress = localStorage.getItem('loginSocketAddress');
    if(isMobile){
        finalURL = (
            TWITCH_OAUTH_URL  + `&state=oldURL-${window.location.href}`);
        window.location.replace(finalURL);
    }
    else{
        finalURL = TWITCH_OAUTH_URL  + `&state=${socketAddress}`;
        let currWindow  = window.open(
	    finalURL, '_blank', 'height=720,width=550');
    }    
}

export async function loginToYoutube(){
    let finalURL;
    const socketAddress = localStorage.getItem('loginSocketAddress');
    console.log('YOUTUBE_OAUTH_URL', YOUTUBE_OAUTH_URL);
    if(isMobile){
        finalURL = (
            YOUTUBE_OAUTH_URL  + `&state=oldURL-${window.location.href}`);
        window.location.replace(finalURL);
    }
    else{
        finalURL = YOUTUBE_OAUTH_URL  + `&state=${socketAddress}`;
        let currWindow  = window.open(
	    finalURL, '_blank', 'height=720,width=550');
    }    
}

export async function loginToYoutubeChatManager(){
    let finalURL;
    const socketAddress = localStorage.getItem('loginSocketAddress');
    console.log('YOUTUBE_OAUTH_URL', YOUTUBE_OAUTH_URL_CHATBOT_MANAGER);
    finalURL = (
        YOUTUBE_OAUTH_URL_CHATBOT_MANAGER  + `&state=oldURL-${window.location.href}`);
    window.location.replace(finalURL);
}


export function getPaymentInformation(){
    let paymentDetailsStr = localStorage.getItem('payment-details');
    let paymentDetails;
    if(paymentDetailsStr){
        paymentDetails = JSON.parse(paymentDetailsStr);
    }
    else{
        return false;
    }
    return paymentDetails;
}

export function getWalletInformation(){
    let walletDetailsStr = localStorage.getItem('wallet-details');
    let walletDetails;
    if(walletDetailsStr){
        walletDetails = JSON.parse(walletDetailsStr);
    }
    else{
        return false;
    }
    return walletDetails;
}

export async function removeCards(){
    let loginInformation = getLoginInformation();
    let resp = await fetch(DELETE_STRIPE_PAYMENTS, {
	method: 'POST',
	headers: {
	    'Accept': 'application/json',
	    'Content-Type': 'application/json',
            "Authorization": `Token ${loginInformation.accessToken}`,
	},
    });
    await setPaymentDetails();
}

export async function setWalletDetails(){
    let loginInformation = getLoginInformation();
    localStorage.setItem('wallet-details', '');
    let resp;
    try{
        resp = await fetch(FETCH_WALLET_DETAILS, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`
	    }
        });
    }
    catch (e){
        localStorage.setItem(
            'wallet-details', '');
        eventBus.dispatch(
            'wallet-details-changed', undefined
        )
        return;
    }
    let respData = await resp.json();
    if(respData.data){
        localStorage.setItem(
            'wallet-details',
            JSON.stringify(respData.data));
        eventBus.dispatch(
            'wallet-details-changed',
            respData.data
        );
    }
    else{
        eventBus.dispatch('wallet-details-changed', undefined);
    }    
    return resp;
}

export async function setSocialHandleInformation(){
    console.log('setting token')
    let loginInformation = getLoginInformation();
    localStorage.setItem(
        'social-information', '');
    let resp;
    try{
        resp = await fetch(`${FETCH_SOCIAL_INFORMATION}${loginInformation.user.uid}`, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`
	    }
        });
    }
    catch (e){
        console.log(e)
        localStorage.setItem(
            'social-information', '');
        eventBus.dispatch(
            'social-information-changed', undefined
        )
        return;
    }
    let respData = await resp.json();
    if(respData.data){
        localStorage.setItem(
            'social-information',
            JSON.stringify(respData.data.user.social));
        eventBus.dispatch(
            'social-information-changed', respData.data
        );
    }
    else{
        eventBus.dispatch('social-information-changed', undefined);
    }    
    return resp;
}
